import { supabase } from "./supabase";

/**
 * Opptaksdagene i produksjonen.
 *
 * HVER DAG HAR ET NUMMER OG EN DATO, og de to følger hverandre ikke av seg
 * selv. «Dag 8» er produksjonens eget nummer og det folk snakker i; datoen er
 * det kalenderen regner i. En dag kan utgå uten at nummereringen forskyves,
 * og da er «dag 7 pluss én» feil. Derfor leses de, aldri regnes ut.
 */

export interface Opptaksdag {
  readonly dag: string;
  /** ISO, «2026-10-18». */
  readonly dato: string;
}

export async function hentDager(produksjonId: string): Promise<Opptaksdag[]> {
  if (supabase === null) return [];
  const { data, error } = await supabase
    .from("shoot_day")
    .select("day, date")
    .eq("production_id", produksjonId)
    .order("date", { ascending: true });
  if (error !== null) return [];
  return (data ?? []).map((r) => {
    const o = r as unknown as Record<string, unknown>;
    return { dag: String(o["day"]), dato: String(o["date"]) };
  });
}

const MAANED = [
  "januar", "februar", "mars", "april", "mai", "juni",
  "juli", "august", "september", "oktober", "november", "desember",
];

/** «18. oktober». Aaret staar ikke her — produksjonen varer ikke saa lenge. */
export function datoTekst(iso: string): string {
  const [aar, m, d] = iso.split("-").map(Number);
  if (aar === undefined || m === undefined || d === undefined) return iso;
  return `${d}. ${MAANED[m - 1] ?? ""}`.trim();
}
